import React from "react";
import PhotoSlider$ from "@deosite/components-new/PhotoSlider";
import ButtonIcon from "@commerce-ui/core2/ButtonIcon";
import ArrowRightIcon from "../../icons/arrow-next.svg";
import ArrowLeftIcon from "../../icons/arrow-previous.svg";

const buttonStyles = {
  fill: "white",
  svg: {
    height: "37px",
    width: "37px"
  }
};

const PhotoSlider = props => (
  <PhotoSlider$
    {...props}
    buttonNext={
      <ButtonIcon sx={buttonStyles}>
        <ArrowRightIcon />
      </ButtonIcon>
    }
    buttonPrevious={
      <ButtonIcon sx={buttonStyles}>
        <ArrowLeftIcon />
      </ButtonIcon>
    }
  />
);

export default PhotoSlider;
